import type { StaticCrew, StaticProject } from "../types";

export function aggregateCrewProjects(crew: StaticCrew) {
	const projects: StaticProject[] = [];

	function push(project: StaticProject) {
		projects.push(project);
	}

	function aggregate(project: StaticProject) {
		const lastIndex = projects.length - 1;
		const lastProject = projects[lastIndex];
		if (!lastProject || lastProject.id !== project.id) {
			push(project);
			return;
		} else {
			projects[lastIndex]?.tickets.push(...project.tickets);
		}
	}

	for (const project of crew.projects) {
		/** IF FIRST PROJECT */
		if (projects.length === 0) {
			push(project);
			continue;
		}
		aggregate(project);
	}

	return projects;
}
